import { FILTER_TYPES, SORT_BY_ACCESS } from '../../../constants/TopFilterConstants';
// @ts-ignore Could not find a declaration file for module
import { useSearchParam } from '../../../hooks/searchParamHooks';
import UsageTracker from '../../../utils/UsageTracker';
import { Select } from 'foundations-components/components/Select';
import { FiltersWrapper } from './FiltersWrapper';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const getOptions = () => SORT_BY_ACCESS.map(sortBy => ({
  text: I18n.text(`academyComponents.topFilters.sortByAccess.${sortBy}`),
  value: sortBy
}));
export const SortByAccess = ({
  appearsIn
}) => {
  const [sortByValue, setSortBy] = useSearchParam(FILTER_TYPES.SORT_BY);
  const sortByAccess = SORT_BY_ACCESS.includes(sortByValue[0]) ? sortByValue : [];
  const handleSortByAccessChange = value => {
    UsageTracker.trackStandalone('Filter Interaction', {
      action: value ? 'filter-selected' : 'filter-deselected',
      value,
      isDropdown: true,
      key: 'sort-by-access',
      appearsIn
    });
    setSortBy(value);
  };
  return /*#__PURE__*/_jsx(FiltersWrapper, {
    children: /*#__PURE__*/_jsx(Select, {
      clearable: true,
      menuInlineSize: 200,
      onSelectedOptionChange: evt => {
        handleSortByAccessChange(evt.value);
      },
      options: getOptions(),
      prefixWithSelectedItemsPlaceholder: true,
      selectedItemsPlaceholder: I18n.text('academyComponents.topFilters.sortByAccess.filterTitle'),
      selectedValues: sortByAccess
    })
  });
};